import { Navigate, useLocation } from "react-router-dom";

export default function LegacyUpcomingMemberElectionDatesRedirect() {
  const location = useLocation();
  return <Navigate to={`/people/membership-services/member-elections/upcoming-dates${location.search}`} replace />;
}
